// extracted by mini-css-extract-plugin
export var infoItem = "_os-2";
export var title = "_os-0";
export var value = "_os-1";